import React from "react";
import { NavLink } from "react-router-dom";
import logoImg from "../logo.svg";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { arrowLeft } from "react-icons-kit/feather/arrowLeft";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import {
  EditCustomerAPI,
  GetCustomerByPhone,
  GetCustomerCity,
  GetCustomerCountry,
  GetCustomerRole,
  GetCustomerState,
  GetCustomerStatus,
} from "../apiconfig/authService";

function EditCustomer(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setCustomerTableViewMessage = props.setMessage;

  const [message, setMessage] = useState("");
  const [isMessageRed, setIsMessageRed] = useState(false);
  const { customerPhoneNumber } = useParams();
  const [rolesData, setRolesData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [customerData, setCustomerData] = useState({});
  const [editedCustomerData, setEditedCustomerData] = useState({});

  const formatUTCDate = (utcDateString) => {
    const date = new Date(utcDateString);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    };
    const readableFormat = date.toLocaleString(undefined, options);
    return readableFormat.substring(0, readableFormat.length - 9);
  };

  useEffect(() => {
    (async () => {
      try {
        const customerResponse = await GetCustomerByPhone(
          customerPhoneNumber, localStorage.getItem("accessToken")
        ); 
        const citiesResponse = await GetCustomerCity(
          localStorage.getItem("accessToken")
        );
        const statesResponse = await GetCustomerState(
          localStorage.getItem("accessToken")
        );
        const countriesResponse = await GetCustomerCountry(
          localStorage.getItem("accessToken")
        );
        const statusResponse = await GetCustomerStatus(
          localStorage.getItem("accessToken")
        );
        const rolesResponse = await GetCustomerRole(
          localStorage.getItem("accessToken")
        );
        setStatusData(statusResponse.data.statuses);
        setRolesData(rolesResponse.data.roles);
        setCustomerData(customerResponse.data);
        setEditedCustomerData(customerResponse.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  const handleStatusChange = (e) => {
    const temp = { ...editedCustomerData };
    temp.customer.statusid = Number(e.target.value);
    setEditedCustomerData(temp);
  };

  const handleDiscardClick = () => {
    const temp = { ...customerData };
    setEditedCustomerData(temp);
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    let response;
    try {
      const { customerphone, statusid } = editedCustomerData.customer;
      response = await EditCustomerAPI(
        { customerphone, statusid },
        localStorage.getItem("accessToken")
      );
      if (response.status === 200) {
        setCustomerTableViewMessage(response.data.message);
        navigate("/customer");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setIsMessageRed(true);
        setMessage(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        setIsMessageRed(true);
        setMessage("An error occurred. Please try again later.");
        window.scrollTo(0, 0);
      }
    }
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Edit Customer</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/customer" className="btn btn-primary">
              View All
            </NavLink>
          </div>
        </div>

        {message && (
          <div
            style={{ color: isMessageRed ? "red" : "black" }}
            className="alert alert-primary"
            role="alert"
          >
            {message}
          </div>
        )}

        <div
          role="tabpanel"
          className="personal-info tab-pane active storetab"
          id="pi"
        >
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-2"> */}
              <label htmlFor="catName">Name</label>
              <input
                type="text"
                value={editedCustomerData?.customer?.name}
                className="form-control custom-input my-3"
                id="catName"
                placeholder="Name"
              />
              {/* </div> */}
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-2"> */}
              <label htmlFor="catName">Phone Number</label>
              <input
                type="text"
                value={editedCustomerData?.customer?.customerphone}
                className="form-control custom-input my-3"
                id="catName"
                placeholder="Phone Number"
              />
              {/* </div> */}
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-2"> */}
              <label htmlFor="catName">Email ID</label>
              <input
                type="text"
                value={editedCustomerData?.customer?.emailid}
                className="form-control custom-input my-3"
                id="catName"
                placeholder="Email ID"
              />
              {/* </div> */}
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-2"> */}
              <label htmlFor="floatingInput">Status</label>
              <select
                className="form-select custom-input my-3"
                onChange={handleStatusChange}
                value={editedCustomerData?.customer?.statusid}
              >
                {statusData?.map((item) => (
                  <option value={item.statusid}>{item.status}</option>
                ))}
              </select>
              {/* </div> */}
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <button
                type="submit"
                onClick={handleDiscardClick}
                className="btn btn-danger  save-btn text-uppercase px-4 my-3"
              >
                Discard
              </button>{" "}
              &nbsp;
              <button
                type="submit"
                onClick={handleSubmitClick}
                className="btn btn-primary  save-btn text-uppercase px-4 my-3"
              >
                Save
              </button>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}
export default EditCustomer;
